import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import bookingChangesApi from '@/features/dashboard/bookingChanges/api/bookingChangesApi.ts';
import { bookingChangesApiQueryKeys } from '@/features/dashboard/bookingChanges/api/bookingChangesApi.queryKeys.ts';

/**
 * Wejście w tryb edycji: tworzy szkic albo zwraca już otwarty.
 *
 * Operacja jest idempotentna po stronie backendu, więc powtórne wejście w tryb
 * edycji nie zakłada drugiej paczki.
 */
const useCreateOrGetDraft = (bookingId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => bookingChangesApi.createOrGetDraft(bookingId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: bookingChangesApiQueryKeys.booking(bookingId),
      });
    },
    onError: (error: Error) => {
      toast.error('Nie udało się otworzyć szkicu zmian', {
        description: error.message,
      });
    },
  });
};

export default useCreateOrGetDraft;
